
export var sloppyClickThreshold = 5;

export default (function (original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
});


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/drag-handle/util/is-sloppy-click-threshold-exceeded.js
// module id = 1891
// module chunks = 1